import React from 'react'
import Box from '@mui/material/Box'

import { ActionCardProps } from 'types/TextAnalysis'
// import { CardCheckbox } from 'components/Shared/ActionCard/Header/CardCheckbox'
import { CardMeta } from 'components/Shared/ActionCard/Header/CardMeta'
import SentimentDropdown from 'components/Shared/SentimentDropdown'
import { SentimentOptions } from 'components/Shared/SentimentDropdown/SentimentOptions'

const HeaderContainer = ({
  // id,
  hover,
  // showCheckbox,
  // $checked,
  showAddTag,
  cardMeta,
  cardActions,
  cardSentiment,
  handleEditSentiment,
}: // handleCheckboxClick,
ActionCardProps) => {
  return (
    <Box
      data-testid="actioncard-header"
      width="100%"
      display="flex"
      justifyContent="space-between"
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      gap={2}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {/* <CardCheckbox
          id={id}
          showCheckbox={showCheckbox}
          $checked={$checked}
          handleCheckboxClick={handleCheckboxClick}
        /> */}
        <CardMeta cardMeta={cardMeta} />
      </Box>
      <>{hover && showAddTag && cardActions}</>
      <Box
        sx={{
          width: { xs: '100%', md: 'auto' },
        }}
      >
        <SentimentDropdown
          options={SentimentOptions}
          sentimentObj={cardSentiment}
          readonly={false}
          handleEditSentiment={handleEditSentiment}
        />
      </Box>
    </Box>
  )
}

export default React.memo(HeaderContainer)
